import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    Row,
    Col,
    Card,
    Media,
    Collapse,
    Form,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingModal from "../../components/Common/LoadingModal"
import { Link } from "react-router-dom";
import Switch from "react-switch";

import {
    setAdmEmailManagementSuccess as setSuccess,
    setAdmEmailManagementLoading as setLoading,
    setAdmEmailManagementAlertMessage as setAlertMessage,
    setAdmEmailManagementError as setError,
    getDppYn,
    updateDppYn
} from "../../store/actions";

import '../../components/Common/Common.css';

const PAUSE_OUTBOUND_EMAILS = "Pause emails from member accounts?"
const RESUME_OUTBOUND_EMAILS = "Enable email sending from all accounts?"

const AdmEmailManagement = props => {
    const dispatch = useDispatch();

    const { loading, success, error, alertMsg, dppYn } = useSelector(state => ({
        loading: state.AdminEmailManagement.loading,
        success: state.AdminEmailManagement.success,
        error: state.AdminEmailManagement.error,
        alertMsg: state.AdminEmailManagement.alertMsg,
        dppYn: state.AdminEmailManagement.dppYn
    }));

    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    const handleDppModeChange = (nextChecked) => {
        console.log(nextChecked)
        dispatch(setAlertMessage())
        if (nextChecked) {
            dispatch(setAlertMessage(PAUSE_OUTBOUND_EMAILS))
        } else {
            dispatch(setAlertMessage(RESUME_OUTBOUND_EMAILS))
        }
    };

    useEffect(() => {
        dispatch(getDppYn());
    }, [])

    return (
        <React.Fragment>
            <Form onSubmit={() => { }}>
                <div className="page-content">
                    <div className="container-fluid">
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <Link className="text-dark" to="#">
                                        <div className="p-4">
                                            <Media className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-3">
                                                    <i className="uil uil-envelope-block text-primary h2"></i>
                                                </div>
                                                <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="font-size-16 mb-1">Admin Email Management</h5>
                                                </div>
                                                {/* <i className={isOpen ? "mdi mdi-chevron-up accor-down-icon font-size-24" : "mdi mdi-chevron-down accor-down-icon font-size-24"} style={{ cursor: "pointer" }}></i> */}
                                            </Media>
                                        </div>
                                    </Link>
                                    <Collapse isOpen={isOpen}>
                                        <div className="p-4 border-top">
                                            <div>
                                                <Row className="mb-3">
                                                    <p className="text-muted mb-3">
                                                        Emergency halt outbound communications immediately 
                                                        if a mistake is detected. Use this control to pause 
                                                        outbound emails while the issue is investigated, 
                                                        or during post-deployment testing to allow for 
                                                        investigation and validation.
                                                    </p>
                                                    <p>
                                                        Switch ON: sending emails <span style={{fontWeight: "bold"}}>only from Cresters' accounts</span>
                                                        <br/>
                                                        Switch OFF (default): sending emails from all member and Crester accounts
                                                    </p>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        // htmlFor="dppYn"
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        DPP mode
                                                    </label>
                                                    <div className="col-md-3 d-flex align-items-center">
                                                        <Switch
                                                            onColor='#5c8dc6'
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            handleDiameter={18}
                                                            activeBoxShadow='0 0 2px 3px #5c8dc6'
                                                            id="dppYn"
                                                            onChange={handleDppModeChange}
                                                            checked={dppYn}
                                                        />
                                                    </div>
                                                </Row>
                                            </div>
                                        </div>
                                    </Collapse>
                                </Card>
                            </Col>
                        </Row>

                        {
                            loading ?
                                <LoadingModal
                                    loading={loading}
                                    setLoading={() => dispatch(setLoading(!loading))}
                                ></LoadingModal>
                                : null
                        }

                        {
                            success ?
                                <SweetAlert
                                    title={success}
                                    timeout={2000}
                                    showCloseButton={false}
                                    showConfirm={false}
                                    success
                                    onConfirm={() => {
                                        dispatch(setSuccess(""));
                                    }}
                                ></SweetAlert>
                                : null
                        }

                        {
                            alertMsg !== '' ? (
                                <SweetAlert
                                    warning
                                    showCancel
                                    confirmBtnText="Confirm"
                                    cancelBtnText="Cancel"
                                    confirmBtnBsStyle="success"
                                    cancelBtnBsStyle="danger"
                                    title={alertMsg}
                                    onConfirm={() => {
                                        if (alertMsg === PAUSE_OUTBOUND_EMAILS) {
                                            dispatch(updateDppYn("Y"))
                                        } else if (alertMsg === RESUME_OUTBOUND_EMAILS) {
                                            dispatch(updateDppYn("N"))
                                        }
                                        dispatch(setAlertMessage(""))
                                    }}
                                    onCancel={() => {
                                        dispatch(setAlertMessage(""))
                                    }}
                                >
                                </SweetAlert>
                            ) : null
                        }

                        {
                            error ? (
                                <SweetAlert
                                    error
                                    onConfirm={() => {
                                        dispatch(setError(""));
                                    }}
                                    onCancel={() => {
                                        dispatch(setError(""));
                                    }}
                                >
                                    {error}
                                </SweetAlert>
                            ) : null
                        }

                    </div>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default AdmEmailManagement;